import { DateTimePicker, type DateTimePickerProps } from "~/components/form/date-picker/DateTimePicker";

export type DatePickerProps = Exclude<DateTimePickerProps, "mode">;

export const DatePicker = ({ label = "Date", ...datePickerProps }: DatePickerProps) => {
    return <DateTimePicker {...datePickerProps} mode="date" label={label} />;
};
